// definicion de la data
export const initialState = {
    usuario: {
        
        email: "",
      
        // 'passowrd'
    },
    activo: false
};
// la data que se va a almacenar dentro de este reducer y leuego en el initialstate
const sesionUsuarioReducer = (state= initialState, action) => {
    switch(action.type) {
        case "INICIAR_SESION" : 
        return {
            ...state,
            usuario : action.sesion,
            activo : action.activo
    };
    case "SALIR_SESION":
        return {
            ...state,
            usuario: action.nuevoUsuario,
            activo : action.activo
        };
    case "ACTUALIZAR_USUARIO" :
        return {
            ...state,
            usuario: action.usuario,
            activo : action.activo
        }
        default :
         return state;
}
};

export default sesionUsuarioReducer;